import React from 'react';
import './Searcher.scss';
//import '../../../styles/svg_icons/logo_main.svg';


export default class Searcher extends React.Component {
    render() {
        return (
            <div className="Searcher">
                <input type="text" placeholder="Армирование"/>
                
            </div>
        )
    }
}